import SelectGender from './select-gender';

const CustomSelectGender = {
    Root: SelectGender,
    name: 'custom-select-render',
};
export type * from './select-gender';
export default CustomSelectGender;
